enum AlertEvents {
  SNACK_BAR_SHOW_ALERT = 'SNACK_BAR_SHOW_ALERT',
}

export default AlertEvents;
